import * as React from "react";

import Page from "../containers/Page";
import Draggable from "../containers/Draggable";
import Dropable from "../containers/Dropable";
import Test from '../containers/Test';

export default () => {
  return (
    <Page title="Scheduled">
      
        <div>
            <Dropable>test</Dropable>
        </div>
        <div style={{ overflow: "hidden", clear: "both" }}>
            <Draggable taskId="Glass">test</Draggable>
            <Draggable taskId="Banana">test2</Draggable>
            <Draggable taskId="Paper">test3</Draggable>
            
        </div>


    <Test />
    </Page>
  );
};
